import { Controller, type Control } from 'react-hook-form';
import { FormInput } from '@/components/FormInput';
import type { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';

interface ContactFieldsProps {
    control: Control<CollaboratorFormData>;
    disabled: boolean;
}

export function ContactFields({ control, disabled }: ContactFieldsProps) {
    return (
        <div className="grid gap-4 sm:grid-cols-2">
            <Controller
                name="personalEmail"
                control={control}
                render={({ field, fieldState }) => (
                    <FormInput
                        label="E-mail pessoal"
                        type="email"
                        autoComplete="email"
                        value={field.value ?? ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        name={field.name}
                        disabled={disabled}
                        error={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                name="phone"
                control={control}
                render={({ field, fieldState }) => (
                    <FormInput
                        label="Telefone com DDD"
                        type="tel"
                        autoComplete="tel"
                        value={field.value ?? ''}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        name={field.name}
                        disabled={disabled}
                        error={fieldState.error?.message}
                    />
                )}
            />
        </div>
    );
}
